import { useEffect } from "react";

export const SITE_URL = "https://www.minipelleberjalienne.com";

/** Per-page SEO updater: title, meta, canonical, og/twitter, robots and optional JSON-LD. */
export default function Seo({ title, description, path = "", image, type = "website", jsonLd, noindex = false }) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    const fullTitle = title ? `${title} | LMB Services` : "LMB Services — Mini-pelles RIPPA neuves & d'occasion, mandat d'import";
    const desc = description || "Vente de mini-pelles RIPPA neuves et d'occasion, mandat d'import sécurisé. Distributeur français.";
    const url = `${SITE_URL}${path}`;
    const img = image || `${SITE_URL}/hero-bg.png`;

    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [a, v] = selector.replace(/^meta|[[\]"]/g, "").split("=");
        el.setAttribute(a, v);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[name="robots"]', "content", noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", img);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('meta[name="twitter:image"]', "content", img);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    if (!jsonLdStr) return undefined;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo-jsonld", "true");
    script.text = jsonLdStr;
    document.head.appendChild(script);
    return () => script.remove();
  }, [title, description, path, image, type, jsonLdStr, noindex]);

  return null;
}
